'use client'

import './LivePlayer.css'

import {useTranslations} from 'next-intl'

import ModalFanClubHandler from '../ModalFanClubHandler'
import ModalHandler from '../ModalHandler'
import ShowNotifyModal from '../ModalShowNotifyPopupITR'
import LoadScript from './LoadScript'

type LivePlayerProps = {
  nBroadNo?: string
}
const LivePlayer = ({nBroadNo}: LivePlayerProps) => {
  const t = useTranslations()

  // document.addEventListener('visibilitychange', () => {
  //   const video = document.getElementById(
  //     'livePlayer',
  //   ) as HTMLVideoElement | null
  //   console.log('video', video)
  //   const audio = new Audio()
  //   if (video && !document.hidden && video.paused) {
  //     console.log('zô ')
  //     audio.play()
  //   }
  // })

  document.addEventListener('visibilitychange', () => {
    const video = document.getElementById(
      'livePlayer',
    ) as HTMLVideoElement | null
    if (video) {
      if (!document.hidden) {
        console.log('Trở lại tab')
        if (video.paused) {
          video.play().catch((err) => console.error('Lỗi phát video:', err))
        }
      } else {
        video.playbackRate = 1
      }
    }
  })

  return (
    <div style={{height: '100%'}}>
      <LoadScript nBroadNo={nBroadNo} />
      <div className="vr_player"></div>
      <div id="afreecatv_player" className="">
        <div className="afreecatv_player_size"></div>

        <ModalHandler />
        <ModalFanClubHandler />
        <ShowNotifyModal />
        <div id="videoLayer"></div>

        <div
          id="videoLayerCover"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2,
            display: 'none',
          }}
        ></div>

        <div className="watermark tl opacity" style={{display: 'none'}}>
          {t('on-live')}
        </div>

        <div className="default_logo">ON Live</div>

        <div className="tooltip" style={{top: '50px', left: '100px'}}>
          <em></em>
        </div>

        <div className="player_info">
          <div id="tuneOut" className="tuneout" style={{display: 'none'}}>
            <p>{t('restream-and-stream-peek-without-prior-consultatio')}</p>
          </div>
          <div className="title">
            <div>
              <span id="bjNick"></span>
              <span id="viewerCnt">
                <em></em>
              </span>
            </div>
            <h1 id="broadTitle"></h1>
            <a href="#" target="_blank"></a>
          </div>
        </div>

        <ul className="view_ctrl in_screen" style={{display: 'none'}}>
          <li className="btn_chat">
            <button type="button">
              <span>{t('cua-so-tro-chuyen-onoff')}</span>
            </button>
          </li>
          <li className="btn_list">
            <button type="button">
              <span>{t('dai-truyen-hinh-onoff')}</span>
            </button>
          </li>
          <li className="btn_list_bookmark">
            <button type="button">
              <span>{t('yeu-thich-onoff')}</span>
            </button>
          </li>
        </ul>

        <div
          className="player_ctrlBox"
          // tabIndex={1}
        >
          <div className="ctrl">
            <div className="progress" style={{display: 'none'}}>
              <div className="progress_track">
                <div className="video_thumbnail time">
                  <span className="reverse_time">
                    <em></em>
                  </span>
                  <span
                    className="dev_positive_time"
                    style={{bottom: '25px', display: 'none'}}
                  >
                    <em></em>
                  </span>
                </div>
                <div className="watched" style={{width: '100%'}}></div>
                <button className="handler" style={{left: '100%'}}>
                  <span></span>
                </button>
                <div
                  className="download"
                  style={{width: '0%', display: 'none'}}
                ></div>
                <div className="progress_bar"></div>
              </div>
            </div>

            <button
              type="button"
              id="time_shift_play"
              className="pause"
              aria-label="Play"
              style={{display: 'none'}}
            ></button>

            <button
              type="button"
              id="play"
              className="play"
              aria-label="Play"
            ></button>

            <div className="volume">
              <button
                type="button"
                className="sound"
                id="btn_sound"
                name="sound"
                aria-label="sound"
              >
                <span></span>
                <span></span>
              </button>
              <div className="volume_slider_wrap">
                <div className="volume_slider">
                  <div className="volume_range" style={{width: '50%'}}></div>
                  <button
                    className="volume_handler"
                    aria-label="volume_handler"
                    style={{left: '50%'}}
                  ></button>
                </div>
              </div>
            </div>
            <button
              type="button"
              id="liveButton"
              aria-label="live_state"
              className="live_state"
              name="live_state"
              style={{display: 'block'}}
            >
              <em></em>
              <span>{t('live')}</span>
            </button>
          </div>

          <div className="right_ctrl">
            <button type="button" className="btn_share"></button>

            <div className="quality_box">
              <button type="button" className="btn_quality_mode">
                <span>{t('medium')}</span>
              </button>
              <ul>
                <li>
                  <button type="button" className="auto_quality">
                    <span>{t('tu-dong')}</span>
                  </button>
                </li>
                <li>
                  <button type="button" className="original_quality">
                    <span>{t('source')}</span>
                  </button>
                </li>
                <li>
                  <button type="button" className="high_quality">
                    <span>{t('cao')}</span>
                  </button>
                </li>
                <li>
                  <button type="button" className="normal_quality">
                    <span>{t('medium')}</span>
                  </button>
                </li>
                <li>
                  <button type="button" className="low_quality">
                    <span>{t('low')}</span>
                  </button>
                </li>
              </ul>
            </div>

            <div className="setting_box" style={{display: 'none'}}>
              <button type="button" className="btn_setting">
                setting
                <div className="tooltip" style={{display: 'none'}}>
                  <span>{t('settings')}</span>
                  <em></em>
                </div>
              </button>
              <div className="setting_list">
                <ul>
                  <li>
                    <button
                      type="button"
                      id="btnLiveCaptionOnOff"
                      style={{display: 'none'}}
                    >
                      <span></span>
                    </button>
                  </li>
                  <li>
                    <button type="button" id="btnCheckPlayerState">
                      <span>{t('diagnose')}</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <button
              type="button"
              className="btn_pip_mode"
              aria-label="Picture-in-Picture"
              style={{display: 'none'}}
              name="pip"
            >
              <div className="tooltip">
                <span>{t('pip-modep')}</span>
                <em></em>
              </div>
            </button>

            <button
              type="button"
              className="btn_smode"
              name="mode"
              aria-label="mode"
            >
              <div className="tooltip">
                <span>{t('cinema-modes')}</span>
                <em></em>
              </div>
            </button>

            <button
              type="button"
              className="btn_extend_mode"
              name="extend_mode"
              aria-label="extend_mode"
            >
              <div className="tooltip">
                <span>{t('full-screenf')}</span>
                <em></em>
              </div>
            </button>
          </div>
        </div>

        <div className="center_btn" style={{display: 'none'}}>
          <button
            type="button"
            className="btn_cneter_play"
            style={{display: 'none'}}
          >
            <span>{t('play')}</span>
          </button>

          <div className="volume_icon" style={{display: 'none'}}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div className="center_msg" style={{display: 'none'}}>
          <span>{t('5-giay')}</span>
        </div>
        <div className="video_blind" style={{display: 'none'}}>
          <div className="video_blind_in">
            <div className="content">
              <div className="dialog type_adult" style={{display: 'none'}}>
                <h2>{t('19')}</h2>
                <p>{t('noi-dung-gioi-han-do-tuoi-chi-co-tren-nguoi')}</p>
                <p>
                  <strong></strong>
                </p>
                <div className="btn_set">
                  <button type="button" className="open">
                    <span>{t('mo-trinh-phat-onlive')}</span>
                  </button>
                </div>
              </div>

              <div className="dialog type_maxuser" style={{display: 'none'}}>
                <h2>
                  Sự tham gia khả thi Số người Vượt quá.
                  <br />
                  {t('please-enter-your-subscriber-only-nickname')}
                </h2>
              </div>
              <div
                className="dialog type_ppv_not_allow"
                style={{display: 'none'}}
              >
                <p>{t('you-can-continue-after-purchasing-a-ticket')}</p>
                <div className="btn_set">
                  <button type="button" className="enter">
                    <span>{t('confirm')}</span>
                  </button>
                </div>
              </div>

              <div
                className="dialog type_ppv_not_login"
                style={{display: 'none'}}
              >
                <p>{t('log-in-required')}</p>
                <div className="btn_set">
                  <button type="button" className="enter">
                    <span>{t('login')}</span>
                  </button>
                </div>
              </div>

              <div className="dialog type_adult_lock" style={{display: 'none'}}>
                <h2>
                  <span className="adult">{t('19')}</span>
                  <span className="lock">{t('lock')}</span>
                </h2>
                <p>
                  Streamer has password-protected this content from those under
                  the age of 19. <br />
                  {t('please-enter-the-password-to-proceed')}
                </p>
              </div>

              <div className="dialog type_continue" style={{display: 'none'}}>
                <h2>{t('please-wait')}</h2>
                <p className="txt">
                  {t('streamer-has-temporarily-stopped-the-stream')}
                </p>
                <p className="txt_desc">
                  It will restart if the issue is resolved <br />
                  {t('within-the-wait-time')}
                </p>
                <span>
                  Waiting Time <em>{t('0000')}</em>
                </span>
              </div>

              <div className="dialog type_password" style={{display: 'none'}}>
                <form
                  name="passwordForm"
                  style={{margin: '0px'}}
                  onSubmit={() => {
                    return false
                  }}
                >
                  <h2>{t('password-protected-stream')}</h2>
                  <p>{t('please-enter-the-password')}</p>
                  <div>
                    <label htmlFor="pwd">{t('password')}</label>
                    <input type="password" id="pwd" />
                  </div>
                  <p className="red" style={{display: 'none'}}>
                    {t('incorrect-password-please-try-again')}
                  </p>
                  <div className="btn_set">
                    <button type="button" className="enter">
                      <span>{t('enter')}</span>
                    </button>{' '}
                    <button type="button" className="close">
                      <span>{t('go-back')}</span>
                    </button>
                  </div>
                </form>
              </div>

              <div className="dialog type_blind" style={{display: 'none'}}>
                <h2>{t('blind')}</h2>
                <strong>
                  You have been banned from the stream for{' '}
                  <span>{t('percents')}</span>
                  {t('minutes-due-to-an-excess-number-of-chatting')}
                </strong>
                <p>
                  When you are block from a stream, <br />
                  you cannot watch the stream or the chat. <br />
                  {t('you-will-not-be-able-to-enter-again-upon-leaving')}
                </p>
              </div>

              <div className="dialog type_end" style={{display: 'none'}}>
                <h2>{t('until-next-time')}</h2>
              </div>

              <div
                className="dialog"
                style={{display: 'none'}}
                id="browserUpDate"
              >
                Flash player support has ended in June 2020.
                <br />
                {t('please-update-your-browser-to-enoy-afreecatv-in-th')}
              </div>

              <div
                className="dialog type_mobile_pause"
                style={{display: 'none'}}
              >
                <h2>{t('stream-has-been-paused')}</h2>
                <p>{t('please-wait-until-the-stream-starts-again')}</p>
              </div>

              <div
                className="dialog type_common"
                style={{display: 'none'}}
              ></div>
            </div>
          </div>
        </div>

        <div className="ui-pop chrome_install" style={{display: 'none'}}>
          <div className="pop-body">
            <strong>{t('try-watching-on-chrome')}</strong>
            <p>
              For more stable viewing,
              <br />
              try using Chrome browser
              <br />
              {t('with-html5-support')}
            </p>
            <a
              href="https://www.google.com/chrome"
              target="_blank"
              className="btn_download"
            >
              Download Chrome
            </a>
          </div>
          <div className="chk-box">
            <input type="checkbox" name="" id="chk1" />
            <label htmlFor="chk1">{t('do-not-show-for-30-days')}</label>
          </div>
          <a href="#" className="pop-close">
            <span>{t('lop-dong')}</span>
          </a>
        </div>

        <div className="loading" style={{display: 'none'}}>
          <div>
            <img
              className="loading_img"
              src="https://res.onlive.vn/images/afreecatv_player/default_loading.gif"
              data-use-ad="1"
              data-tracking-tag=""
              alt="đang tải hình ảnh"
            />
          </div>
        </div>

        <div className="buffering" style={{display: 'none'}}>
          <span></span>
        </div>

        <div className="da_area" style={{display: 'none'}}>
          <a href="#"></a>
        </div>
        <button
          type="button"
          style={{display: 'none'}}
          className="da_area_left"
          id="da_btn_click"
        >
          <span>{t('click')}</span>
          <em>{t('0000')}</em>
        </button>
        <button
          type="button"
          style={{display: 'none'}}
          className="da_area_right"
          id="da_btn_skip"
        >
          <span>
            Skip AD after <em>{t('percents')}</em>
            {t('seconds')}
          </span>
        </button>

        <div id="tuneOut" className="tuneout" style={{display: 'none'}}>
          <p>{t('restream-and-stream-peek-without-prior-consultatio')}</p>
        </div>

        <div className="item_ten" style={{display: 'none'}}>
          <div className="blind">{t('hot-10-minutes')}</div>
          <div className="min">{t('1')}</div>
          <div className="min2">
            This will automatically be UPed in <strong>{t('percents')}</strong>
            {t('seconds')}
          </div>
          <button type="button" className="btn_up">
            <span className="blind">{t('up-express')}</span>
          </button>
          <button type="button" className="btn_next">
            <span className="blind">{t('next-time')}</span>
          </button>
          <button type="button" className="btn_close">
            <span className="blind">{t('close')}</span>
          </button>
        </div>

        <div className="break_time" id="breakTimeBox" style={{display: 'none'}}>
          <p>
            <strong>
              <i></i>
              <em></em>The stream will continue after the break time.{' '}
            </strong>
            {t('please-wait-while-watching-the-ads-to-support-the-')}
          </p>
        </div>

        <div className="adballoon_icon" style={{display: 'none', zIndex: 999}}>
          <a href="#" className="adcon-area" style={{zIndex: 999}}>
            <span className="thumb">
              <img src="" />
            </span>
            <span className="con_desc">
              <span className="area">
                <em className="con_tit">{t('adcon')}</em>
                <span className="con_stit">{t('select-streamers-adcon')}</span>
              </span>
            </span>
          </a>
          <button type="button" className="adballoon_close">
            <span></span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default LivePlayer
